import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SimpleBaseForm } from 'app/core/components/simple-base-form';
import { ProfileDetailsModel } from 'app/core/model/profileDetailsModel';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { EnumService } from 'app/core/services/enum.service';
import { ProfileService } from 'app/core/services/profile.service';
import { LoginService } from 'app/login/services/login.service';
import { SideBarService } from 'app/core/services/side-bar.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { businessCategory, Language } from 'app/shared/model/enums';
import { AppAuthService } from 'app/shared/services/app-auth.service';
import { CommonService } from 'app/shared/services/common.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { setAuthData } from 'app/shared/state/actions/user.actions';
import { AuthData } from 'app/shared/model/auth-data.model';
import { LAST_CONNECTED_EMAIL, LAST_CONNECTED_LANGUAGE } from 'app/shared/model/local-storage-keys';
import { ChangePasswordComponent } from 'app/login/components/change-password/change-password.component';

@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileDetailsComponent extends SimpleBaseForm implements OnInit {
  @Input()
  businessId: number;
  hasPassword: boolean;

  protected get form(): NgForm {
    return this.profileDetailsForm;
  }
  public save(args?: any): Observable<any> {
    if (this.businessId)
      this.profileDetailsModel.BusinessId = this.businessId;

    if (this.profileDetailsModel.BusinessDetails.CategoryId != null)
      this.profileDetailsModel.BusinessDetails.CategoryId = this.profileDetailsModel.BusinessDetails.CategoryId.value;

    return this.profileService.saveConnectedBusinessInfo(this.profileDetailsModel).pipe(
      map(res => {
        this.profileDetailsModel.BusinessDetails.CategoryId = this.bussinessCategory.find(
          x => x.value === this.profileDetailsModel.BusinessDetails.CategoryId
        );
        if (!this.businessId) {
          this.localizationService.changeLanguage(this.profileDetailsModel.BusinessDetails.Language);
          this.commonService.changeCurrentPageHeader(this.localizationService.Translate('PROFILE.TITLE'));
        }
        else
            this.commonService.changeCurrentPageHeader(this.profileDetailsModel.BusinessDetails.BusinessName);

        this.messageService.successMessage('GENERAL.MESSAGES.SAVED_SUCCESSFULY', true);
        this.cdr.markForCheck();
      }),
      catchError(err => {
        this.messageService.errorMessage('GENERAL.MESSAGES.SAVE_NOT_SUCCED', true);
        this.cdr.markForCheck();
        return of(null);
      })
    );
  }

  @ViewChild("profileDetailsForm") profileDetailsForm: NgForm;
  @ViewChild(ChangePasswordComponent) changePasswordDialog: ChangePasswordComponent;

  _allCountries;
  _allCities;
  lang = Language
  cities;
  countries;
  languages
  BusinessCategory = businessCategory;
  bussinessCategory: any[] = [];
  subscriptions = new Subscription();
  currentLang
  profileDetailsModel: ProfileDetailsModel = null
  constructor(
    private loginService: LoginService,
    private store: Store<AppState>,
    sideBarService: SideBarService,
    cdr: ChangeDetectorRef,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    router: Router,
    messageService: AdvMessageService,
    private commonService: CommonService, private _enumService: EnumService, private profileService: ProfileService, private authService: AppAuthService) {
    super(messageService, localizationService, route, sideBarService, cdr, router);
    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.currentLang = language;
    }));
  }
  //   protected loadData(): Observable<any> {
  //     // return this.getProfileDetails()
  // }

  ngOnInit(): void {
    this.getCategoriesList();
    this.languages = this._enumService.getEnumValues(this.lang);
    this.commonService.getCountriesList().subscribe((res: any) => {
      this._allCountries = res.result.records.map(c => c['שם_ארץ'].trim());
    });
    this.commonService.getIsraelCities().subscribe((res: any) => {
      this._allCities = res.map(c => c.name.trim())
    });
  }
  getProfileDetails() {
    this.profileService.getConnectedBusinessInfo(this.businessId || 0).subscribe((res: any) => {
      this.profileDetailsModel = res;
      this.profileDetailsModel.BusinessDetails.CategoryId = this.bussinessCategory.find(x => x.value === this.profileDetailsModel.BusinessDetails.CategoryId);
      this.hasPassword = res.ManagerDetails.HasPassword;
      this.cdr.markForCheck();
    });
  }
  getCategoriesList(): void {
    this.loginService.getCategoriesTypes(this.currentLang).subscribe((res: any) => {
      if (res.Category) {
        this.bussinessCategory = res.Category.map(category => { return { description: category.Description, value: category.Id }; });
        const otherCategory = this.bussinessCategory.find(c => c.value == this.BusinessCategory.other);
        if (otherCategory) {
          this.bussinessCategory = [...this.bussinessCategory.filter(c => c.value != this.BusinessCategory.other), otherCategory];
        }
      }
      this.getProfileDetails()
    })
  }
  filterCities(event: any) {
    if (this.profileDetailsModel.BusinessDetails.Language != Language.he || this.profileDetailsModel.BusinessDetails.Country != 'ישראל') {
      this.cities = []
    }
    else {
      if (this._allCities.find(x => x === event.query) && event.originalEvent.type == 'click') {
        this.cities = [...this._allCities];
      }
      else {
        this.cities = [...this._allCities.filter(x => x.includes(event.query))];
      }
    }
  }
  filterCountries(event: any) {
    if (this.profileDetailsModel.BusinessDetails.Language != Language.he) {
      this._allCountries = []
    }
    else {
      if (this._allCountries.find(x => x == event.query) && event.originalEvent.type == 'click') {
        this.countries = [...this._allCountries];
      }
      else {
        this.countries = [...this._allCountries.filter(x => x.includes(event.query))];
      }
    }

  }
  logout() {
    this.authService.logout();
  }
  onPasswordUpdated(hasPassword: boolean) {
    this.hasPassword = hasPassword;
    this.cdr.markForCheck()
  }
}
